import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import { UpdateAppConfigPayload } from 'BoostXpressAdmin/Model/appConfigXModel'

export const appConfigBXService = {
  getAppConfigs: async () => {
    return AuthXInterceptor.get('app-update/config')
  },

  updateAppConfig: async (payload: UpdateAppConfigPayload) => {
    return AuthXInterceptor.put('app-update/config', payload)
  },
}
